<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Pilih Item</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <SearchBox v-model="searchMenu" placeholder="Cari Menu" class-add="w-full" />
        <LocalFilterLane :items="allItemCategories" class-add="my-3" @setCurrentItem="setCurrentItem" />
        <TableComponent>
          <TableHead>
            <TableRow>
              <TableHeadCell>Kode</TableHeadCell>
              <TableHeadCell>Nama Item</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow v-if="allItems.length == 0">
              <TableCell colspan="6" customClass="text-center italic text-gray-400 dark:text-gray-500" noTextColor>
                Belum ada data
              </TableCell>
            </TableRow>
            <TableRow v-else v-for="(item, index) in allItems" :key="item.id" :index="index" alternateRow isBody>
              <TableCell>{{ item.code }}</TableCell>
              <TableCell>
                <div class="flex items-center gap-1">
                  <label for="">{{ item.name }}</label>
                  <CheckCircleIcon v-if="selectedItem.filter((i) => i.id == item.id).length > 0" class="h-4 w-4 bg-success text-white rounded-full" />
                </div>
              </TableCell>
              <TableCell>
                <div class="flex items-center">
                  <button v-if="selectedItem.filter((i) => i.id == item.id).length == 0" :id="'edit-data-' + item.id"
                    @click="choose(item)"
                    class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                    <CheckCircleIcon class="h-4 w-4 group-hover:text-green-700" />
                  </button>
                  <button v-if="selectedItem.filter((i) => i.id == item.id).length > 0" @click="removeItem(item)"
                    class="border border-gray-400 hover:border-red-700 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                    <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                  </button>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </TableComponent>
        <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-primary hover:bg-hover-primary text-white"
            @click="submit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import SubmitButton from '../form/SubmitButton.vue';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { CheckCircleIcon, TrashIcon } from '@heroicons/vue/24/outline';
import PaginationButtons from '@/components/PaginationButtons.vue';
import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import LocalFilterLane from '@/views/pages/new-transaction/order/LocalFilterLane.vue';

export default {
  name: "ModalChooseProduct",
  components: {
    SubmitButton,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
    PaginationButtons,
    CheckCircleIcon,
    TrashIcon,
    SearchBox,
    LocalFilterLane,
  },
  data() {
    return {
      showModal: true,
      selectedItem: [],
      selectedCategory: null,
      searchMenu: "",
      currentPage: 1,
      totalPages: 1,
      fields: ['qty'],
      validation: {
        qty: {
          valid: true,
          message: '',
        },
      },
      searchTimeout: null,
    }
  },
  computed: {
    ...mapGetters('items', {
      allItems: 'allItems',
    }),
    ...mapGetters("item_categories", ["allItemCategories"]),
    filteredItems() {
      // Filter item berdasarkan kategori yang dipilih
      let result = this.allItems;
      result = result.map((item) => {
        item.itemCategory = this.allItemCategories.find(
          (ic) => ic.id == item.item_category_id
        );
        return item;
      });

      result = result.filter((item) => item.itemCategory !== undefined);
      if (this.searchMenu)
        result = result.filter(
          (item) =>
            item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
        );
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.item_category_id === this.selectedCategory
        );
      }
      return result;
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.$emit('closeModal');
      }
      if (newVal === true) {
        this.fetchItems({ page: 1 });
      }
    },
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchItems({ page: newVal });
      },
    },
    searchMenu: {
      immediate: true,
      handler() {
        // Clear any existing timeout
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        // Set a new timeout
        this.searchTimeout = setTimeout(() => {
          this.fetchItems({ page: 1 });
        }, 1000); // 1 second delay
      },
    },
    selectedCategory: {
      immediate: true,
      handler() {
        this.fetchItems({ page: 1 });
      },
    },
  },
  methods: {
    async fetchItems(params = { page: 1, limit: 5 }) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 5;

      try {
        const response = await this.$store.dispatch("items/fetchItems", { limit: 10000 });

        if (!response) {
          return;
        }

        // 2. Get all items from the store with proper null checking
        const storeItems = this.$store.getters["items/allItems"];
        
        if (!Array.isArray(storeItems)) {
          return;
        }

        const allItems = [...storeItems];
        
        if (allItems.length === 0) {
          // Reset store with empty array to prevent undefined errors
          this.$store.commit("items/resetItems");
          this.$store.commit("items/setItems", []);
          this.totalPages = 1;
          this.currentPage = 1;
          return;
        }

        // Filter item berdasarkan kategori yang dipilih
        let result = allItems;
        result = result.map((item) => {
          item.itemCategory = this.allItemCategories.find(
            (ic) => ic.id == item.item_category_id
          );
          return item;
        });

        result = result.filter((item) => item.itemCategory !== undefined);
        if (this.searchMenu)
          result = result.filter(
            (item) =>
              item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
          );
        if (this.selectedCategory) {
          result = result.filter(
            (item) => item.item_category_id === this.selectedCategory
          );
        }

        // 3. Get IDs of selected items (checking both id and item_id for compatibility)
        const selectedIds = Array.isArray(this.selectedItem)
            ? this.selectedItem.map(item => item?.id || item?.item_id).filter(Boolean)
            : [];

          // 4. Sort items - selected items first, then by active status, and finally by their original order
          const sortedItems = [...result].sort((a, b) => {
            if (!a || !b) {
              return 0;
            }
            // Check if items are selected
            const aSelected = selectedIds.includes(a.id);
            const bSelected = selectedIds.includes(b.id);
            
            // Selected items come first
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            
            // Then sort by active status (active first)
            if (a.is_active && !b.is_active) return -1;
            if (!a.is_active && b.is_active) return 1;
            
            // Maintain original order for items with same status
            return 0;
          });

        // 5. Apply client-side pagination
        const page = params.page || 1;
        const limit = params.limit || 5;
        const startIndex = (page - 1) * limit;
        const paginatedItems = sortedItems.slice(startIndex, startIndex + limit);
        
        // 6. Update store with paginated and sorted items
        this.$store.commit("items/resetItems");
        this.$store.commit("items/setItems", { 
          data: paginatedItems,
          pagination: {
            total: sortedItems.length,
            totalPages: Math.ceil(sortedItems.length / limit),
            currentPage: page,
            perPage: limit
          }
        });
        
        // 7. Update pagination info based on all items
        this.totalPages = Math.ceil(sortedItems.length / limit);
        this.currentPage = page;
      } catch (error) {
        console.error('Error in fetchItems:', error);
        console.error('Error details:', {
          message: error.message,
          stack: error.stack,
          params
        });
        // Reset to empty state on error
        this.$store.commit("items/resetItems");
        this.$store.commit("items/setItems", []);
        this.totalPages = 1;
        this.currentPage = 1;
      }
    },
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    choose(item) {
      this.selectedItem = [...this.selectedItem, item];
      this.fetchItems({ page: 1 });
    },
    removeItem(item) {
      this.selectedItem = this.selectedItem.filter((i) => i.id !== item.id);
      this.fetchItems({ page: 1 });
    },
    setCurrentItem(item) {
      this.selectedCategory = item;
    },
    submit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.$emit('submit', this.selectedItem);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
  },
  async created() {
    await this.$store.dispatch("item_categories/fetchItemCategories", {
      limit: 1000,
      status: "active",
    });
    await this.fetchItems();
  }
}
</script>
